import { managerAxios } from './baseApis';
const endpoint = 'summary';
export const getTeamSummary = async () => {
    return await managerAxios.get(endpoint);
};
